import { useLang } from "@/context/LanguageContext";
import { Reveal, MaskedLines } from "./Reveal";

export const Philosophy = () => {
  const { t } = useLang();
  const p = t.philosophy;

  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="bg-surface py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="overline mb-6">{p.overline}</p>
            </Reveal>
            <h2 className="heading-serif whitespace-pre-line text-4xl leading-[1.02] tracking-tight text-forest sm:text-5xl lg:text-6xl">
              <MaskedLines lines={p.title.split("\n")} trigger="load" />
            </h2>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <div className="flex flex-col">
              {p.chapters.map((c, i) => (
                <Reveal key={c.no} delay={i * 0.08}>
                  <div className="grid grid-cols-[auto_1fr] gap-6 border-t border-line py-8 md:gap-10 md:py-10">
                    <span className="heading-serif text-4xl leading-none text-terracotta md:text-5xl">
                      {c.no}
                    </span>
                    <div>
                      <h3 className="heading-serif text-2xl text-forest md:text-3xl">
                        {c.title}
                      </h3>
                      <p className="body-text mt-3 max-w-md">{c.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
